import { SchemaValidationError } from '@helpers';
import { ZodError, ZodIssue, ZodSchema } from 'zod';

export type ValidateResponseSchemaProps<T> = {
  data: T;
  endpoint: string;
  schema: ZodSchema<T>;
};

export const validateResponseSchema = <T>({
  data,
  endpoint,
  schema,
}: ValidateResponseSchemaProps<T>): SchemaValidationError | false => {
  try {
    schema.parse(data);
    return false;
  } catch (error) {
    if (error instanceof ZodError) {
      const flattenedError = error.flatten((issue: ZodIssue) => ({
        message: issue.message,
        errorCode: issue.code,
        path: issue.path,
      }));

      return new SchemaValidationError(endpoint, flattenedError);
    }

    throw error as Error;
  }
};
